/**
 * Construit un arbre récursif à partir d'une liste plate de catégories.
 * Supporte N niveaux de profondeur.
 * Chaque noeud reçoit une propriété `children` (tableau, vide si feuille)
 * et `aggregated` avec les totaux récursifs (transactions_count_30d, total_month_cents).
 */
export function buildCategoryTree(categories) {
  const childrenByParent = new Map();

  for (const c of categories) {
    if (c.parent_id) {
      if (!childrenByParent.has(c.parent_id)) childrenByParent.set(c.parent_id, []);
      childrenByParent.get(c.parent_id).push(c);
    }
  }

  function buildNode(cat) {
    const rawChildren = childrenByParent.get(cat.id) ?? [];
    const children = rawChildren
      .map(buildNode)
      .sort((a, b) => (b.total_month_cents ?? 0) - (a.total_month_cents ?? 0));

    const aggTx =
      (cat.transactions_count_30d ?? 0) +
      children.reduce((s, c) => s + (c.aggregated.transactions_count_30d ?? 0), 0);
    const aggAmount =
      (cat.total_month_cents ?? 0) +
      children.reduce((s, c) => s + (c.aggregated.total_month_cents ?? 0), 0);

    return {
      ...cat,
      children,
      aggregated: {
        transactions_count_30d: aggTx,
        total_month_cents: aggAmount,
      },
    };
  }

  const roots = categories.filter((c) => !c.parent_id);
  return roots.map(buildNode);
}
